import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LOGIN_URL } from '../utils';

const Login = () => {
  const [username, setUsername] = useState(''); // State for username
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();

  // Helper function for validation
  const validateForm = () => {
    const errors = {};

    // Username validation (minimum length of 2 characters)
    if (!username) {
      errors.username = 'Username is required';
    } else if (username.length < 2) {
      errors.username = 'Username must be at least 2 characters long';
    }

    // Password validation (minimum length of 6 characters)
    if (!password) {
      errors.password = 'Password is required';
    } else if (password.length < 6) {
      errors.password = 'Password must be at least 6 characters long';
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const response = await axios.post(LOGIN_URL, { username, password });
        console.log({response})
        const { token } = response?.data;

        // Store token in localStorage
        localStorage.setItem('token', token);
        window.location.href = '/orders';
      } catch (error) {
        // Show API error on frontend
        setApiError(error.response?.data?.message || 'Login failed. Please try again.');
      }
    }
  };

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="80vh" 
      bgcolor="#FFF" 
      p={3}
    >
      <Box
        width="100%"
        maxWidth="400px"
        p={4}
        borderRadius={4}
        boxShadow={3}
        bgcolor="#FFF"
      >
        <Box display="flex" justifyContent="center" mb={2}>
          <img src="/logo.png" alt="Logo" style={{ width: '80%', height: 'auto' }} />
        </Box>
        <Typography variant="h4" color="#BA9F52" mb={2} textAlign="center" style={{fontFamily: "cursive"}}>
          Login
        </Typography>
        <form onSubmit={handleSubmit} noValidate>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            error={!!errors.username}
            helperText={errors.username}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password}
          />
          {apiError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {apiError}
            </Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              bgcolor: '#BA9F52',
              color: '#FFF',
              '&:hover': { bgcolor: '#BA9F52' },
            }}
          >
            Login
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default Login;
